export const heroData = {
  title: "SAIVILLA DREAMHOUSE",
  subtitle: "Luxury Living in the Heart of Palanpur",
  description: "Experience premium residential & commercial spaces with world-class amenities at affordable rates",
  ctaText: "Explore Properties",
  ctaSecondary: "Schedule Visit"
};

export const aboutData = {
  title: "About SAIVILLA DREAMHOUSE PVT.LTD.",
  description: "Located in the prime location of Palanpur, Gujarat, SAIVILLA DREAMHOUSE PVT.LTD. is committed to creating exceptional residential and commercial spaces that blend luxury with affordability. Our projects feature state-of-the-art amenities including swimming pools, theaters, gyms, and clubhouses, designed to elevate your lifestyle.",
  stats: [
    { number: "15+", label: "Years Experience" },
    { number: "25+", label: "Projects Delivered" },
    { number: "5000+", label: "Happy Families" },
    { number: "100%", label: "Customer Satisfaction" }
  ]
};

export const projectsData = [
  {
    id: 1,
    name: "Sai Legacy",
    type: "Flats",
    status: "Ongoing",
    image: "https://customer-assets.emergentagent.com/job_saivilla-homes/artifacts/cepcjj8s_55888-1.jpg",
    price: "Contact for Pricing",
    bhk: "2, 3 BHK",
    area: "Modern Spacious Layouts",
    location: "Near Underpass, Ahmedabad Highway, Palanpur",
    description: "Modern Living Apartment - A New Standard in Luxury Living. G+14 storey building with basement parking, featuring over 15 premium amenities including yoga deck, terrace garden, gym, club house, 24x7 security, and more.",
    gallery: [
      "https://customer-assets.emergentagent.com/job_saivilla-homes/artifacts/cepcjj8s_55888-1.jpg",
      "https://customer-assets.emergentagent.com/job_saivilla-homes/artifacts/y0sv8tzi_588%281%29.png",
      "https://customer-assets.emergentagent.com/job_saivilla-homes/artifacts/jhspv8u3_14858-1.jpg"
    ],
    highlights: [
      "G+14 Storey with Basement Parking",
      "Earthquake Resistant RCC Structure",
      "15+ Premium Amenities",
      "Prime Highway Location",
      "Near Bus Depot & Key Facilities",
      "Vitrified Flooring Throughout",
      "Machine-less Automatic Lift",
      "24x7 CCTV Security"
    ],
    brochure: "https://customer-assets.emergentagent.com/job_saivilla-homes/artifacts/54ngfnx8_Sai%20Legacy%20Brochure%20%281%29.pdf"
  },
  {
    id: 2,
    name: "Sai Villa 10",
    type: "Villa",
    status: "Available Now",
    image: "https://customer-assets.emergentagent.com/job_saivilla-homes/artifacts/2mynnaet_SV10%20CAm_03_VIew.jpg",
    price: "Contact for Pricing",
    bhk: "3 BHK & 4 BHK Modern Bungalows",
    area: "900-1275 sq.ft (Plot Area)",
    location: "Nr. Upasana Vidhyalaya, Ahmedabad-Palanpur Highway",
    description: "Modern Bungalows with Smart Planning & Good Design. Experience luxury living amidst nature with exclusive clubhouse featuring gym, home theater, multipurpose hall, and beautifully landscaped gardens.",
    gallery: [
      "https://customer-assets.emergentagent.com/job_saivilla-homes/artifacts/2mynnaet_SV10%20CAm_03_VIew.jpg",
      "https://customer-assets.emergentagent.com/job_saivilla-homes/artifacts/v17316dt_SV10%20CAm_012_VIew.jpg",
      "https://customer-assets.emergentagent.com/job_saivilla-homes/artifacts/xr66ps2x_SV10%20CAm_013_VIew.jpg",
      "https://customer-assets.emergentagent.com/job_saivilla-homes/artifacts/f6cgpt38_SV10%20CAm_014_VIew.jpg",
      "https://customer-assets.emergentagent.com/job_saivilla-homes/artifacts/qra2sccq_SV10%20CAm_015_VIew.jpg",
      "https://customer-assets.emergentagent.com/job_saivilla-homes/artifacts/9b1gwrej_SV10%20CAm_016_VIew.jpg",
      "https://customer-assets.emergentagent.com/job_saivilla-homes/artifacts/bvkdl73n_SV10%20CAm_018_VIew.jpg"
    ],
    highlights: [
      "Gold - 3 BHK (900 sq.ft plot) - 40 Units",
      "Platinum - 4 BHK (1066 sq.ft plot) - 20 Units",
      "Diamond - 4 BHK (1275 sq.ft plot) - 26 Units",
      "Exclusive Clubhouse with Modern Amenities",
      "Home Theater & Fully Equipped Gym",
      "Earthquake Resistant Structure",
      "Lush Open Spaces & Gardens",
      "Premium CP Fittings & Sanitary Ware",
      "20 Commercial Shops Available"
    ],
    brochure: "https://customer-assets.emergentagent.com/job_saivilla-homes/artifacts/krm3jm2y_Sai%20Villa%2010.pdf"
  },
  {
    id: 3,
    name: "Sai Villa 6",
    type: "Villa",
    status: "Available",
    image: "https://customer-assets.emergentagent.com/job_saivilla-homes/artifacts/5ip5tmmr_IMG-20220106-WA0000%20%282%29.jpg",
    price: "Contact for Pricing",
    bhk: "3 BHK & 4 BHK Luxurious Bungalows",
    area: "760-1200 sq.ft",
    location: "Opp. Riddhi Siddhi Party Plot, Ahmedabad Highway, Palanpur",
    description: "A wholesome lifestyle awaits you at Sai Villa 6. Experience the perfect blend of nature and modern living in these thoughtfully designed luxurious bungalows with planned township featuring temple, jogging track, and comprehensive amenities.",
    gallery: [
      "https://customer-assets.emergentagent.com/job_saivilla-homes/artifacts/5ip5tmmr_IMG-20220106-WA0000%20%282%29.jpg",
      "https://customer-assets.emergentagent.com/job_saivilla-homes/artifacts/aw3wk9ny_BIRD%20VIew_View.jpg",
      "https://customer-assets.emergentagent.com/job_saivilla-homes/artifacts/gnhs1ze9_CAm-01%20ok%20_View.jpg",
      "https://customer-assets.emergentagent.com/job_saivilla-homes/artifacts/d6e7xe4r_CAm-03_G2_View.jpg",
      "https://customer-assets.emergentagent.com/job_saivilla-homes/artifacts/jqtabxgd_CAm-04_View.jpg"
    ],
    highlights: [
      "Diamond - 4 BHK (1200 sq.ft) - 11 Units",
      "Platinum - 3 BHK (960 sq.ft) - 61 Units",
      "Gold - 3 BHK (840 sq.ft) - 25 Units",
      "Silver - 3 BHK (760 sq.ft) - 22 Units",
      "Total 119 Units",
      "Temple & Jogging Track",
      "Gymnasium & Indoor Games",
      "24x7 Security with CCTV",
      "Club House with Garden"
    ],
    brochure: "https://customer-assets.emergentagent.com/job_saivilla-homes/artifacts/pxvhn7ga_Sai%20Villa%206.pdf"
  },
  {
    id: 4,
    name: "Sai Villa 7",
    type: "Villa",
    status: "Premium",
    image: "https://customer-assets.emergentagent.com/job_saivilla-homes/artifacts/r3kuvzl2_PHOTO-2021-07-15-13-21-22.jpg",
    price: "Contact for Pricing",
    bhk: "3 BHK & 4 BHK Luxurious Bungalows",
    area: "810-1224 sq.ft",
    location: "Nr. Sandipani International School, Ahmedabad-Palanpur Highway",
    description: "Uplifting Lifestyle with premium luxurious bungalows featuring thoughtful design and modern aesthetics. Enjoy premium amenities including swimming pool, gym, home theater, and beautifully landscaped gardens.",
    gallery: [
      "https://customer-assets.emergentagent.com/job_saivilla-homes/artifacts/r3kuvzl2_PHOTO-2021-07-15-13-21-22.jpg",
      "https://customer-assets.emergentagent.com/job_saivilla-homes/artifacts/8z3slf2d_PHOTO-2021-07-15-13-21-47.jpg",
      "https://customer-assets.emergentagent.com/job_saivilla-homes/artifacts/wjnwugcu_PHOTO-2021-07-15-13-22-02.jpg",
      "https://customer-assets.emergentagent.com/job_saivilla-homes/artifacts/q6ak4rhq_PHOTO-2021-07-15-13-22-19.jpg",
      "https://customer-assets.emergentagent.com/job_saivilla-homes/artifacts/7czjb85w_CAm-10_View.jpg",
      "https://customer-assets.emergentagent.com/job_saivilla-homes/artifacts/o05zskxy_PHOTO-2021-07-15-13-22-35.jpg",
      "https://customer-assets.emergentagent.com/job_saivilla-homes/artifacts/4d7c40w7_PHOTO-2021-07-15-13-22-47.jpg",
      "https://customer-assets.emergentagent.com/job_saivilla-homes/artifacts/9nga1oph_PHOTO-2021-07-15-13-23-01.jpg"
    ],
    highlights: [
      "Diamond+ - 4 BHK (1224 sq.ft) - 32 Units",
      "Diamond - 4 BHK (1007 sq.ft) - 34 Units",
      "Platinum+ - 3 BHK (915 sq.ft) - 29 Units",
      "Platinum - 3 BHK (810 sq.ft) - 32 Units",
      "Swimming Pool & Home Theater",
      "Fully Equipped Gymnasium",
      "Yoga/Meditation Area",
      "Lotus Pond & Water Body",
      "Children Play Area"
    ],
    brochure: "https://customer-assets.emergentagent.com/job_saivilla-homes/artifacts/tt27v9uz_Sai%20Villa%207.pdf"
  },
  {
    id: 5,
    name: "Sai Iconic",
    type: "Commercial",
    status: "New Launch",
    image: "https://customer-assets.emergentagent.com/job_saivilla-homes/artifacts/zo3k16o0_RW_Sai%20iconic_bird%20eye%20view.jpg",
    price: "Contact for Pricing",
    area: "277-1276 sq.ft",
    location: "Opp. Shiv Plaza, Palanpur-Ahmedabad Highway",
    description: "Palanpur's most iconic commercial landmark featuring futuristic design. Premium retail shops and corporate offices with comprehensive amenities, strategic highway location, and modern infrastructure for your business success.",
    gallery: [
      "https://customer-assets.emergentagent.com/job_saivilla-homes/artifacts/zo3k16o0_RW_Sai%20iconic_bird%20eye%20view.jpg",
      "https://customer-assets.emergentagent.com/job_saivilla-homes/artifacts/1nu7rni9_RW_Sai%20iconic_closeup%20view.jpg",
      "https://customer-assets.emergentagent.com/job_saivilla-homes/artifacts/qgpqnjjw_RW_Sai%20iconic_corner%20view.jpg",
      "https://customer-assets.emergentagent.com/job_saivilla-homes/artifacts/25jmjl1y_RW_Sai%20iconic_entry%20view.jpg",
      "https://customer-assets.emergentagent.com/job_saivilla-homes/artifacts/j2hqcpu6_RW_Sai%20iconic_balcony%20view.jpg"
    ],
    highlights: [
      "Ground & First Floor - Retail Shops",
      "2nd, 3rd & 4th Floor - Premium Offices",
      "Luxurious Reception Area",
      "2 Branded Elevators",
      "24x7 Security & CCTV",
      "Basement & Covered Parking",
      "Meeting Area & Garden Spaces",
      "Strategic Highway Location"
    ],
    brochure: "https://customer-assets.emergentagent.com/job_saivilla-homes/artifacts/1d9e49ha_Sai%20Iconic.pdf"
  }
];

export const amenitiesData = [
  { id: 1, name: "Swimming Pool", icon: "Waves", image: "https://images.unsplash.com/photo-1711110065918-388182f86e00?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBzd2ltbWluZyUyMHBvb2wlMjBJbmRpYSUyMHJlc29ydHxlbnwwfHx8fDE3NjgwNDM1MjR8MA&ixlib=rb-4.1.0&q=85", description: "Olympic-size swimming pool with kids' area and poolside deck" },
  { id: 2, name: "Modern Gym", icon: "Dumbbell", image: "https://images.unsplash.com/photo-1599121118834-14b8ab00020c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBneW0lMjBmaXRuZXNzJTIwY2VudGVyJTIwSW5kaWF8ZW58MHx8fHwxNzY4MDQzNTI3fDA&ixlib=rb-4.1.0&q=85", description: "Fully-equipped fitness center with latest equipment and trainers" },
  { id: 3, name: "Clubhouse", icon: "Users", image: "https://images.unsplash.com/photo-1761971976592-58882ab1cacc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBjbHViaG91c2UlMjBpbnRlcmlvciUyMGxvdW5nZXxlbnwwfHx8fDE3NjgwNDQwNDd8MA&ixlib=rb-4.1.0&q=85", description: "Luxurious clubhouse for social gatherings and events" },
  { id: 4, name: "Theater", icon: "Film", image: "https://images.unsplash.com/photo-1710131459450-7c384b8be18f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxwcml2YXRlJTIwaG9tZSUyMGNpbmVtYSUyMHRoZWF0ZXIlMjBsdXh1cnl8ZW58MHx8fHwxNjgwNDQwNDh8MA&ixlib=rb-4.1.0&q=85", description: "Private movie theater with premium seating and acoustics" },
  { id: 5, name: "Children Play Area", icon: "Baby", description: "Safe and fun play zone with modern equipment for kids" },
  { id: 6, name: "Yoga & Meditation", icon: "Sparkles", description: "Dedicated space for yoga, meditation and wellness activities" },
  { id: 7, name: "24/7 Security", icon: "Shield", description: "CCTV surveillance and trained security personnel" },
  { id: 8, name: "Power Backup", icon: "Zap", description: "100% power backup for uninterrupted living" },
  { id: 9, name: "Parking", icon: "Car", description: "Ample covered parking space for residents and visitors" },
  { id: 10, name: "Landscaped Gardens", icon: "TreePine", description: "Beautiful green spaces and walking paths" }
];

export const testimonialsData = [
  { id: 1, name: "Rajesh Patel", location: "Sai Villa Heights, Palanpur", rating: 5, image: "https://api.dicebear.com/7.x/avataaars/svg?seed=Rajesh123&backgroundColor=b6e3f4", review: "Very good experience with SAIVILLA DREAMHOUSE team. Quality of construction is top class and all amenities are provided as promised. Mr. Suresh and team were very helpful throughout. Highly satisfied with our 3BHK flat.", date: "2 months ago" },
  { id: 2, name: "Priya Shah", location: "Dreamhouse Flats, Palanpur", rating: 5, image: "https://api.dicebear.com/7.x/avataaars/svg?seed=PriyaShah456&backgroundColor=ffd5dc", review: "We are very happy with our decision to buy home here. Location is excellent - near to schools, market, hospital everything. Price was also reasonable compared to other projects. Thank you Saivilla team for making our dream home!", date: "3 months ago" },
  { id: 3, name: "Amit Desai", location: "Sai Iconic, Palanpur", rating: 5, image: "https://api.dicebear.com/7.x/avataaars/svg?seed=AmitDesai789&backgroundColor=c0aede", review: "Best commercial space for business in Palanpur. Highway location gives good visibility and customer footfall is very nice. Parking facility is also there which is important. Overall very satisfied, would recommend to others also.", date: "4 months ago" },
  { id: 4, name: "Meera Joshi", location: "Sai Villa 7, Palanpur", rating: 5, image: "https://api.dicebear.com/7.x/avataaars/svg?seed=MeeraJoshi321&backgroundColor=ffdfbf", review: "Living experience is wonderful! Swimming pool, gym, all facilities are well maintained. Society people are also very nice and cooperative. Kids are enjoying the play area very much. Worth every rupee we invested.", date: "5 months ago" },
  { id: 5, name: "Kiran Kumar", location: "Sai Villa 10, Palanpur", rating: 5, image: "https://api.dicebear.com/7.x/avataaars/svg?seed=KiranKumar654&backgroundColor=d1d4f9", review: "Excellent villa project with modern design and all amenities. Construction quality is premium class. Home theater and clubhouse facilities are superb. Saivilla developers delivered everything on time as committed. Fully satisfied!", date: "1 month ago" },
  { id: 6, name: "Neha Thakkar", location: "Sai Legacy, Palanpur", rating: 5, image: "https://api.dicebear.com/7.x/avataaars/svg?seed=NehaThakkar987&backgroundColor=b6e3f4", review: "We shifted here 6 months back and very happy with the decision. Flat is spacious with good natural light and ventilation. Society maintenance is also very good. Location wise also very convenient - market, bus stand, schools all nearby. Good value for money.", date: "6 months ago" }
];

export const contactData = {
  phone: "+91 94263 19628",
  phone2: "+91 97252 08524",
  phone3: "+91 63570 08496",
  email: "saivillaoffice@gmail.com",
  website: "www.saivilladevelopers.com",
  address: "Palanpur, Gujarat, India",
  officeHours: "Mon - Sat: 10:00 AM - 7:00 PM"
};
